import React from "react"
import VacationDayVariantChip from "../../../components/molecules/VacationDayVariantChip.molecule"
import { VACATION_DAY_TYPES } from "../../../consts/modules/vacations.consts"

export function VacationSingleDayToUse({ availableDaysList }) {
  if (
    availableDaysList.bucketDays !== null &&
    availableDaysList.bucketDays > -3
  ) {
    return <VacationDayVariantChip dayType={VACATION_DAY_TYPES.BUCKET} />
  } else if (
    availableDaysList.plusDays !== null &&
    availableDaysList.plusDays > 0
  ) {
    return <VacationDayVariantChip dayType={VACATION_DAY_TYPES.PLUS} />
  } else if (
    availableDaysList.additionalDays !== null &&
    availableDaysList.additionalDays > 0
  ) {
    return <VacationDayVariantChip dayType={VACATION_DAY_TYPES.EXTRA} />
  }
}
